import React from "react";

const IconMinus = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={4}
      viewBox="0 0 18 4"
      fill="none"
      {...props}
    >
      <path
        d="M0.5625 0.824829V3.17512H17.0145V0.824829H0.5625Z"
        fill="white"
      />
    </svg>
  );
};

export default IconMinus;
